import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  root: {
    width: 1,
    height: 57,
    borderLeft: 'dashed 0.5px #ababab',
    marginTop: 5,
    paddingRight: 7
  }
})

export default useStyles
